import { Services } from '@omnia/ui/src/lib/services'
import type { Film } from '@vista-digital/ocapi-types/v1'
import type { FilmHeroBannerProps } from '@vista-digital/occ-ui'
import type { NestedPartial } from '@vista-digital/utilities'
import { Alignment, type CarouselConfig } from '../OccCarousel'
import { getBrowsingConfiguration } from './utils/get-browsing-configuration'
import { getBrowsingLanguageText } from './utils/get-browsing-language-text'

export interface HeroBannerProps {
    carouselConfig: CarouselConfig
    filmHeroBannerCommonProps: NestedPartial<FilmHeroBannerProps>
}

export const useGetHeroBannerPageProps = (componentName: string, carouselItemCount: number): HeroBannerProps => {
    const filmsConfig = getBrowsingConfiguration()?.films

    const { showActionButton, showPlayTrailerButton } = filmsConfig?.filmHeroBanner ?? {
        showActionButton: true,
        showPlayTrailerButton: true,
    }

    const { films: filmsLanguageText } = getBrowsingLanguageText({ contentName: componentName })

    const carouselConfig: CarouselConfig = {
        settings: {
            slidesToScroll: 'auto',
            watchDrag: true,
            loop: true,
            breakpoints: { '(min-width: 768px)': { slidesToScroll: 1, dragFree: false } },
            align: Alignment.Center,
        },
        showPositionIndicators: carouselItemCount >= 2,
        autoPlay: {
            // On vista-digital, the autoPlay.delay 5000 for hero banner in lumos web
            delay: 5000,
            enabled: carouselItemCount >= 2,
            showToggle: true,
        },
    }

    const filmHeroBannerCommonProps: NestedPartial<FilmHeroBannerProps> = {
        displayText: filmsLanguageText.omnichannel.filmHeroBanner,
        config: { actionButton: { show: showActionButton }, playTrailerButton: { show: showPlayTrailerButton } },
        events: {
            onActionButtonClicked: (film: Film) =>
                Services.NavigationService.goTo(Services.UrlService.getFilmDetailsUrl(film)),
        },
    }

    return { carouselConfig, filmHeroBannerCommonProps }
}
